import React from "react";
import RangeDataOption from "./RangeDataOption";
import { getRUCEmpresa } from "redux/actions/userActions";
import { useSelector } from "react-redux";
//libreria de consulta de apis
import { httpReportes } from "configurations/axios";
import { useSnackbar } from "notistack";
import { makeStyles, CircularProgress, Backdrop } from "@material-ui/core";
import { parseDate } from "utils/checkDate";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "350px",
  },
  backdrop: {
    zIndex: "3000",
    color: "#fff",
  },
}))
const ReportRetention = () => {
  const tokenUser = useSelector((state) => state.user.tk);
  const { enqueueSnackbar } = useSnackbar();
  var fileSaver = require("file-saver");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);


  function generateReport(startDate, endDate) {
    if (startDate && endDate && (parseDate(startDate, 1).valueOf() < parseDate(endDate, 2).valueOf())) {
      let objReport = {};
      objReport = {
        fechaFin: parseDate(endDate, 2),
        fechaInicio: parseDate(startDate, 1),
        rucEmpresa: tokenUser ? getRUCEmpresa(tokenUser) : "",
      };
      getReportIssued(objReport);
    } else {
      if (startDate == null) {
        enqueueSnackbar(`Seleccione una año`, {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          autoHideDuration: 4000,
        });
      }
      if (endDate == null) {
        enqueueSnackbar(`Seleccione un mes`, {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          autoHideDuration: 4000,
        });
      }
      if (parseDate(startDate, 1).valueOf() > parseDate(endDate, 2).valueOf()) {
        enqueueSnackbar(`Ingreso de rango de fechas incorrecto `, {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          autoHideDuration: 4000,
        });
      }
    }
  }

  const getReportIssued = async (objReport) => {
    setOpen(true);
    await httpReportes
      .post("/reportes/ats/retenciones", objReport, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (response.status === 200) {
          var blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let rucEmpresa = tokenUser ? getRUCEmpresa(tokenUser) : "";
          fileSaver.saveAs(blob, "REPORTE-RETENCIONES-RECIBIDAS-" + rucEmpresa + ".xlsx");
          setOpen(false);
        }
      })
      .catch(() => {
        enqueueSnackbar(`No existen datos para los filtros seleccionados`, {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setOpen(false);
      });
  };

  return (
    <div>
      <Backdrop open={open} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <RangeDataOption
        generateReport={generateReport}
        title={"Reporte retención"}
      ></RangeDataOption>
    </div>
  );
};

export default ReportRetention;
